const tray = {
  title: "Work Tray",
  pinToTray: "Pin to Tray",
  unpinFromTray: "Unpin from Tray",
  clearAll: "Clear All",
  emptyTray: "Tray is empty — pin pages to continue later",
  splitLeft: "Split Left",
  splitRight: "Split Right",
  closeSplit: "Close Split",
  splitActive: "Split screen active",
} as const;
export default tray;
